import type { Group } from './PricingTable'

// What the channel still lacks before its pricing task can be submitted, from
// the rows on screen. Mirrors Plan::ProductsPricingCompletion (the server
// re-checks on Submit); computed client-side so the label moves as cells are typed.
// Prices only exist per price level, so a channel with no levels (wholesale,
// priced by target ASP alone) is never asked for them.
export function pricingMissing(groups: Group[], priceLevelCount: number): string[] {
  const rows = groups.flatMap((group) => group.rows)
  const missing: string[] = []
  if (rows.length === 0) missing.push('products')
  const anyPrice = rows.some((row) => Object.values(row.prices_by_level_id).some(Boolean))
  if (priceLevelCount > 0 && !anyPrice) missing.push('prices')
  if (!rows.some((row) => row.asp)) missing.push('ASPs')
  return missing
}
